import React from "react";

import Image from "components/AppImage";
import Button from "components/ui/Button";

const expiringMembers = [
{ id: 1, name: "Sarah Mitchell", plan: "Premium Annual", daysLeft: 2, avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b98e6da6-1772609107086.png", avatarAlt: "Professional woman with brown hair smiling in gym attire", branch: "Downtown" },
{ id: 2, name: "James Thornton", plan: "Standard Monthly", daysLeft: 3, avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f9f29d10-1768654318201.png", avatarAlt: "Athletic man with short dark hair wearing fitness clothes", branch: "Westside" },
{ id: 3, name: "Priya Sharma", plan: "Premium Monthly", daysLeft: 5, avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10b1bc657-1763300591628.png", avatarAlt: "Young woman with long black hair in workout outfit", branch: "North Park" },
{ id: 4, name: "Carlos Rivera", plan: "Basic Monthly", daysLeft: 6, avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103124391-1763295520525.png", avatarAlt: "Hispanic man with beard wearing casual gym wear", branch: "Downtown" },
{ id: 5, name: "Emily Watson", plan: "Premium Annual", daysLeft: 7, avatar: "https://images.unsplash.com/photo-1675339740471-4e9e51637fc0", avatarAlt: "Blonde woman in athletic wear with ponytail smiling", branch: "East End" }];


export default function ExpiringMemberships() {
  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 shadow-[var(--shadow-sm)]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-heading)]">Expiring Memberships</h3>
        <span className="text-xs text-[var(--color-primary)] font-medium font-[var(--font-caption)] cursor-pointer hover:underline">View All (41)</span>
      </div>
      <div className="space-y-2.5">
        {expiringMembers?.map((member) =>
        <div key={member?.id} className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
              <Image src={member?.avatar} alt={member?.avatarAlt} className="w-full h-full object-cover" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-[var(--color-foreground)] font-[var(--font-caption)] truncate">{member?.name}</p>
              <p className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)] truncate">{member?.plan} · {member?.branch}</p>
            </div>
            <div className={`flex-shrink-0 px-2 py-1 rounded-full text-xs font-medium font-[var(--font-caption)] ${
          member?.daysLeft <= 3 ? "bg-[var(--color-error)]/10 text-[var(--color-error)]" :
          member?.daysLeft <= 5 ? "bg-[var(--color-warning)]/10 text-[var(--color-warning)]" : "bg-[var(--color-muted)] text-[var(--color-muted-foreground)]"}`
          }>
              {member?.daysLeft}d
            </div>
          </div>
        )}
      </div>
      <div className="mt-4 pt-3 border-t border-[var(--color-border)]">
        <Button variant="outline" size="sm" fullWidth iconName="Send" iconPosition="left" iconSize={14}>
          Send Renewal Reminders
        </Button>
      </div>
    </div>);

}